import React, { useEffect, useState } from "react";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import * as queries from "../../graphQLModel/queries";
import awsconfig from "../../aws-config";
import InfiniteScroll from "react-infinite-scroll-component";

Amplify.configure(awsconfig);

// let nextTokenPage = null;
export default function History({ hideLoadingValue, showLoadingValue }) {
  const [resultList, setResultList] = useState([]);
  useEffect(() => {
    getList();
  }, []);
  const getList = async () => {
    try {
      showLoadingValue();
      const {
        data: { listResults },
      } = await API.graphql(
        graphqlOperation(queries.listResults, {
          limit: 100,
          // nextToken: nextTokenPage,
        })
      );
      // nextTokenPage = listResults.nextToken;
      setResultList([...listResults.items]);
    } catch (err) {
      console.log(err);
      hideLoadingValue();
    }
    hideLoadingValue();
  };

  return (
    <div style={{ background: "#fff" }}>
      {/* <InfiniteScroll
        dataLength={true}
        next={getList}
        hasMore={true}
        loader={<h4>Loading...</h4>}
      > */}
        <table className="striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Result</th>
            </tr>
          </thead>

          <tbody>
            {resultList.map((item) => (
                  <tr key={item.id}>
                    <th>{new Date(item.createdAt).toLocaleString()}</th>
                    <th>
                      {item.result == "00000" ? "Access Approved" : item.result}
                    </th>
                  </tr>
                ))}
          </tbody>
        </table>
      {/* </InfiniteScroll> */}
    </div>
  );
}
